import { z } from 'zod';

export const emailSchema = z.string().email('유효한 이메일 주소를 입력해주세요.');

export const passwordSchema = z
  .string()
  .min(8, '비밀번호는 최소 8자 이상이어야 합니다.')
  .regex(/[A-Za-z]/, '영문자를 포함해야 합니다.')
  .regex(/[0-9]/, '숫자를 포함해야 합니다.');

export const phoneSchema = z
  .string()
  .regex(/^01[016789]-?\d{3,4}-?\d{4}$/, '유효한 전화번호를 입력해주세요.')
  .optional();

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  name: z.string().min(2, '이름은 최소 2자 이상이어야 합니다.').max(50),
  phone: phoneSchema,
});

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, '비밀번호를 입력해주세요.'),
});

export const propertySearchSchema = z.object({
  search: z.string().optional(),
  type: z.string().optional(),
  dongtanArea: z.string().optional(),
  minPrice: z.coerce.number().min(0).optional(),
  maxPrice: z.coerce.number().min(0).optional(),
  minArea: z.coerce.number().min(0).optional(),
  maxArea: z.coerce.number().min(0).optional(),
  minFloor: z.coerce.number().optional(),
  maxFloor: z.coerce.number().optional(),
  buildYearFrom: z.coerce.number().min(1970).optional(),
  transactionType: z.string().optional(),
  floorCategory: z.enum(['FIRST', 'LOW', 'MID', 'HIGH', 'TOP']).optional(),
  minUnits: z.coerce.number().min(0).optional(),
  maxUnits: z.coerce.number().min(0).optional(),
  approvalDate: z.string().optional(),
  sort: z
    .enum(['price_asc', 'price_desc', 'area', 'newest', 'relevance'])
    .default('newest'),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(100).default(20),
  lat: z.coerce.number().optional(),
  lng: z.coerce.number().optional(),
  radius: z.coerce.number().min(100).max(10000).optional(),
});

export const simulationSchema = z.object({
  propertyId: z.string().optional(),
  purchasePrice: z.number().min(0, '매매가를 입력해주세요.'),
  purchaseDate: z.string(),
  holdingPeriodYears: z.number().min(1).max(30),
  financingRatio: z.number().min(0).max(1),
  interestRate: z.number().min(0).max(20),
  expectedRentalYield: z.number().min(0).max(20).optional(),
  annualExpenseRate: z.number().min(0).max(10).optional(),
  scenario: z.enum(['BASE', 'OPTIMISTIC', 'PESSIMISTIC']).default('BASE'),
});

export type RegisterInput = z.infer<typeof registerSchema>;
export type LoginInput = z.infer<typeof loginSchema>;
export type PropertySearchInput = z.infer<typeof propertySearchSchema>;
export type SimulationInput = z.infer<typeof simulationSchema>;
